import { createElement } from "react";
import { downloadFile } from "@/utils/downloadFile";
import { CertificateData, certificateFileName } from "./certificateData";

export async function downloadCertificate(
  data: CertificateData,
): Promise<void> {
  const [{ pdf }, { CertificateDocument }] = await Promise.all([
    import("@react-pdf/renderer"),
    import("./TrainingCertificate"),
  ]);

  // pdf() is typed for a Document element rather than a wrapper component, so
  // the element is cast on the way in.
  const element = createElement(CertificateDocument, { items: [data] });
  const blob = await pdf(element as Parameters<typeof pdf>[0]).toBlob();

  downloadFile(blob, certificateFileName(data));
}
